import type { AnyFilterDef } from "../defs/BaseFilterDef"
import type { FilterSchemaDefConfig } from "./typings"

export const createFilterDefConfig = <TData, TFilterDef extends AnyFilterDef>(
	conifg: FilterSchemaDefConfig<TData, TFilterDef>,
) => conifg
